import React, { useState } from "react";
import { Button } from "@mui/material";
import AlertDialog from "./AlertDialog";
import {Routes} from "react-router-dom"
import axios from "axios";

const ResourcesItem = ({
  eachItem,
  downloadPDF,
  deleteResource,
  getAllResources,
}) => {
  const [status, setStatus] = useState(eachItem?.isActive);
  const [showStatusAlertDialog, setShowStatusAlertDialog] = useState(false);
  const [showDeleteAlertDialog, setShowDeleteAlertDialog] = useState(false);

  const changeStatus = async () => {
    //console.log(e.target.checked);
    try {
      const response = await axios.put(
        ` https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/resources/update-status`,
        {
          isActive: !status,
          resourceId: eachItem.resourceId,
        }
      );
      console.log(response);
      setStatus((prev) => !prev);
    } catch (err) {
      console.error(err);
      alert("Some error occured. Please try again.");
    }
  };
  const deleteResourceItem = async () => {
    await deleteResource(eachItem.resourceId);
  };
  const handleClickOpen = () => {
    setShowStatusAlertDialog(true);
  };
  return (
    <>
      <tr>
        <td>{eachItem.resourceType}</td>
        <td>
          <Button
            color="primary"
            variant="contained"
            onClick={() => downloadPDF(eachItem?.url)}
            style={{
              backgroundColor: "rgb(80, 72, 229)",
            }}
          >
            View Pdf
          </Button>
        </td>
        {/* <td>{eachItem.isActive ? "Active" : "Inactive"}</td> */}
        <td>
          <Routes
            checked={status}
            color="success"
            onChange={(e) => setShowStatusAlertDialog(true)}
          />
        </td>
        <td>
          {" "}
          <Button
            color="error"
            variant="outlined"
            onClick={() => setShowDeleteAlertDialog(true)}
          >
            Delete
          </Button>
        </td>
      </tr>
      {showStatusAlertDialog && (
        <AlertDialog
          showAlertDialog={showStatusAlertDialog}
          setShowAlertDialog={setShowStatusAlertDialog}
          submitHandler={changeStatus}
          text="Are you sure you want to change the status?"
        />
      )}
      {showDeleteAlertDialog && (
        <AlertDialog
          showAlertDialog={showDeleteAlertDialog}
          setShowAlertDialog={setShowDeleteAlertDialog}
          submitHandler={deleteResourceItem}
          text="Are you sure you want to delete the resource?"
        />
      )}
    </>
  );
};

export default ResourcesItem;
